import * as modalDialog from "modalDialog";
import models from "models/models";
import * as spanTranslator from "spanTranslator";

export const goToLocation = (
  fromOrTo: "from" | "to",
  position: number,
  appRouter
) => {
  appRouter.navigate(
    `/library/${models.bookModel.id}/${fromOrTo}/${position}`,
    {
      trigger: true,
    }
  );
};

export const showSpecificLocationModal = (appRouter, readerViewModel) => {
  let inputRef: any;

  const onSubmit = () => {
    const rawValue = inputRef.value;
    const value = parseInt(rawValue, 10);

    if (!value) {
      alert("Invalid value");
      return;
    }

    if (value < 0 || value > models.bookModel.get("totalWords")) {
      alert(
        "You need to enter a number between 0 and " +
          models.bookModel.get("totalWords")
      );
      return;
    }

    goToLocation("from", value, appRouter);
  };

  modalDialog.showPreactComponent(
    <div>
      <p>
        You are currently at location{" "}
        {spanTranslator.getRange(readerViewModel.get("firstSpan")).from}.
      </p>
      <p>Enter location from 0 to {models.bookModel.get("totalWords")}:</p>
      <input
        autoFocus={true}
        type="text"
        ref={(ref) => (inputRef = ref)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            onSubmit();
          }
        }}
      />
      <p>
        <button
          onClick={() => {
            onSubmit();
          }}
        >
          Go to location
        </button>
      </p>
    </div>,
    {
      heading: "Go to specific location",
      onShow: () => {
        inputRef.focus();
      },
    }
  );
};
